import domtoimage from 'dom-to-image-more';
import { DocumentationService } from '../services/documentation.service';
import { LanguageService } from '../services/language.service';
import { ConvertToImageModuleExecuter } from '../workflow/modules/convertToImage/convertToImage.settings';
import { InjectorHelper } from './injector.helper';

// @dynamic
export class DocumentationHelper {
    static ExportDocumentation(docID, layout) {
        if (layout && layout.DocumentationDescriptions) {
            const dd = layout.DocumentationDescriptions.find(x => x.ID == docID);
            if (dd) {
                const result = {
                    ScreenshotObject: null,
                    DocumentObjects: []
                };
                if (dd.ScreenshotObject) {
                    result.ScreenshotObject = {
                        ID: dd.ScreenshotObject
                    };
                }
                if (dd.DocumentObjects) {
                    dd.DocumentObjects.forEach(x => {
                        result.DocumentObjects.push({
                            ID: x
                        });
                    });
                }
                DocumentationHelper.SearchElements(layout, result);
                DocumentationHelper.GetScreenShot(result.ScreenshotObject).then(screenShot => {
                    const query = JSON.parse(JSON.stringify(dd));
                    query.ScreenshotObject = screenShot;
                    const screenShots = [];
                    result.DocumentObjects.forEach(docObj => {
                        if (docObj.Screenshot) {
                            screenShots.push(docObj.Screenshot);
                        }
                    });
                    Promise.all(screenShots).then(resultList => {
                        query.DocumentObjects = resultList.filter(x => x != null);
                        var service = InjectorHelper.InjectorInstance.get<DocumentationService>(DocumentationService);
                        service.GenerateDocumentation(query).subscribe(x => {
                            if (x) {
                                const url = URL.createObjectURL(x.body);
                                window.open(url, '_blank');

                                //var fileLink = document.createElement('a');
                                //fileLink.href = url;
                                //fileLink.target = '_blank';
                                //if (x.headers) {
                                //    const cd = x.headers.get('content-disposition');
                                //    if (cd) {
                                //        const splits = cd.split(';');
                                //        splits.some(split => {
                                //            if (split.indexOf('filename=') > -1) {
                                //                fileLink.download = split.split('=')[1];
                                //                return true;
                                //            }
                                //            return false;
                                //        });
                                //    }
                                //}
                                //fileLink.click();
                            }
                        });
                    });
                });
            }
        }
    }

    private static SearchElements(layout, result) {
        if (layout) {
            if (result.ScreenshotObject && result.ScreenshotObject.ID == layout.ID) {
                result.ScreenshotObject.Element = layout;
            }
            if (result.DocumentObjects && layout.ElementType == 'documentation' && layout.DocumentationSettings) {
                result.DocumentObjects.some(x => {
                    if (x.ID == layout.ID) {
                        if (layout.Element && typeof layout.Element.getScreenShot === 'function') {
                            x.Screenshot = layout.Element.getScreenShot();
                        }
                        return true;
                    }
                    return false;
                });
            }
            if (layout.Elements) {
                layout.Elements.forEach(x => {
                    DocumentationHelper.SearchElements(x, result);
                });
            }
        }
    }

    private static GetScreenShot(screenshotObject) {
        return new Promise<any>(resolve => {
            if (screenshotObject && screenshotObject.Element) {
                let htmlElement = document.getElementById('LE_' + screenshotObject.Element.ID);
                if (htmlElement) {
                    ConvertToImageModuleExecuter.beforeScreenShot(screenshotObject.Element);
                    domtoimage
                        .toPng(htmlElement)
                        .then(function (image) {
                            ConvertToImageModuleExecuter.afterScreenShot(screenshotObject.Element);
                            resolve(image);
                        })
                        .catch(function (error) {
                            ConvertToImageModuleExecuter.afterScreenShot(screenshotObject.Element);
                            resolve(null);
                        });
                    return;
                }
            }
            resolve(null);
        });
    }
}